import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../../../components/GeoProvider'
import ErrorMessage from '../../../../components/Layout/ErrorMessageNew'
import DisplayDateFluNew from '../../../../components/DisplayDateFluPharma/DisplayDateFluNew'
import Spinner from '../../../../components/Loader/Spinner'
import MapOptions from '../../../../components/MapOptions'
import EmptyMap from '../../../../components/Map/emptyMap'
import Timeline from '../../../../components/Timeline'
import Map from '../../../../components/Map'
import regionDisplayOptions from './regionDisplayOptions'
import dataDisplayOptions from './dataDisplayOptions'
import toolTipFormatter from './toolTipFormatter'
import MapLegend from './cdcMapLegendHorizontal'
import StateStats from './StateStats'
import CbsaStats from './CbsaStats'
import Zip3Stats from './Zip3Stats'
import Gender from '../../../GenderAge/index'
import SeasonalPattern from '../../../SeasonalPattern'
import Search from '../../../../components/SearchPharma'
import getVectorImage from '../../../../utils/getVectorImage'
import { lastDisplayDate, lastweekEndDate } from '../../dates'
import { lastDisplayDateNew } from '../../dates'
import ExportExcelApi from '../../../../utils/ExportExcelApi'
import styles from './FluGeo.module.scss'
import FluDetailedViewComponent from './FluDetailedViewComponent'
import FluMsaApi from './FluMsaApi'
import Toggle from './Toggle'
import typeDisplayOptions from '../../../Dashboard/typeDisplayOptions'
import SelectList from '../../../../components/SelectList'
import DefaultBreadcrumbs from '../../../../components/Breadcrumbs/DefaultBreadcrumbsPharma'

const FluGeo = () => {
  const entity = 'flu'
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const chartRef = useRef(null)
  const location = useLocation()
  const hash = location.hash

  const [states, setStates] = useState()
  const [metros, setMetros] = useState()
  const [zip3s, setzip3] = useState()
  const [getMapStates, setMapStates] = useState()
  const [activeCbsaForSearch, setActiveCbsaForSearch] = useState()
  const [activeZip3ForSearch, setactiveZip3ForSearch] = useState()
  const [getStatesCombinedData, setStatesCombinedData] = useState()
  const [getExportData, setExportData] = useState()
  const [searchCriteria, setSearchCriteria] = useState([])
  const [getActiveCBSA, setActiveCBSA] = useState()
  const [getActiveZip3, setActiveZip3] = useState()
  const [getActiveZip3Locations, setActiveZip3Locations] = useState()
  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getPercentage, setPercentage] = useState('')
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [toggleEnabled, setToggleEnabled] = useState(false)
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    exportButtonState,
    setExportButtonState,
    exportButtonEnable,
    setExportButtonEnable,
  } = useGeoState()

  const setExcelRowData = (data) => {
    setExportData(data)
  }
  const handleClick = () => {
    setExportButtonState(true)
  }

  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }
  const [getCbsaJsonFile, setCbsaJsonFile] = useState()
  const [getStateJsonFile, setStateJsonFile] = useState()
  const [getZip3JsonFile, setZip3JsonFile] = useState()
  useEffect(() => {
    let url = `${window.location.origin}/usStatesAll_pharma.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        // console.log(data)
        setStateJsonFile(data)
      })
      .catch(function (err) {
        console.log(err, ' error file load usStatesAll ')
      })
  }, [1])

  useEffect(() => {                      
    let url = `${window.location.origin}/cb_2018_us_cbsa_20m_wkid102004_pharma.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        // console.log(data)
        setCbsaJsonFile(data)
      })
      .catch(function (err) {
        console.log(err, ' error file load MultipleMSAsFluMeter')
      })
  }, [1])

  useEffect(() => {
    let url = `${window.location.origin}/three_dig_zips.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setZip3JsonFile(data)
      })
      .catch(function (err) {
        console.log(err, ' error file load us_hrr_values ')
      })
  }, [1])

  const { data: headerDisplayData, error: headerDisplayDataError } =
    useGeoFetch(lastweekEndDate, lastweekEndDate, entity, 'NAT')

  useEffect(() => {
    if (headerDisplayData !== null && headerDisplayData !== undefined) {
      if (headerDisplayData.response_code === 200) {
        if (Object.keys(headerDisplayData.response_data).length > 0) {
          setgeoid('US')
          let obj = headerDisplayData.response_data[lastweekEndDate]?.NAT;
          setistrue(
            obj.change_percentage > 0 ? true : false
          )
          setPercentage(parseFloat(obj.change_percentage).toFixed(2))
          setDatavalue(parseFloat(obj.forecast_value).toFixed(2))
        }
      } else {
        seterrorOccured(true)
      }
    }
  }, [headerDisplayData])

   const { data: forecastAndActualsData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'fluMap',
    'STATE',
    '',
    {
      'geo_parent' : 'US'
    }
  )

  useEffect(() => {
    if (forecastAndActualsData !== null && forecastAndActualsData !== undefined) {
      if (forecastAndActualsData.response_code === 200) {
        setMapStates(forecastAndActualsData.response_data)
      } else {
        setErrorCode(forecastAndActualsData.response_code)
        setErrorMessage(forecastAndActualsData.response_message)
        setErrorSubject(forecastAndActualsData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [forecastAndActualsData])

  const { data: statesData, error: stateDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    entity,
    'state'
  )

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        setStates(statesData.response_data)
        setExportButtonEnable(true)
      } else {
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statesData])

  // // Metro Area Data
  // const { data: cbsaTodayData, error: cbsaTodayDataError } = useGeoFetch(
  //   lastDisplayDateNew,
  //   lastDisplayDateNew,
  //   entity,
  //   'msa'
  // )

  // useEffect(() => {
  //   if (cbsaTodayData !== undefined) {
  //     if (cbsaTodayData.response_code === 200) {
  //       if (Object.keys(cbsaTodayData.response_data).length > 0)
  //         setMetros(cbsaTodayData.response_data)
  //     } else {
  //       setErrorCode(cbsaTodayData.response_code)
  //       setErrorMessage(cbsaTodayData.response_message)
  //       setErrorSubject(cbsaTodayData.response_subject)
  //       seterrorOccured(true)
  //     }
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cbsaTodayData])

  const { data: cbsaData, error: cbsaDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    entity,
    'msa'
  )

  useEffect(() => {
    if (cbsaData !== null && cbsaData !== undefined) {
      if (cbsaData.response_code === 200) {
        if (Object.keys(cbsaData.response_data).length > 0)
          setMetros(cbsaData.response_data)
      } else {
        setErrorCode(cbsaData.response_code)
        setErrorMessage(cbsaData.response_message)
        setErrorSubject(cbsaData.response_subject)
        seterrorOccured(true)
      }
    }
    //setMetros(cbsaData)
  }, [cbsaData])

  // // Zip 3
  // const { data: zip3TodayData, error: zip3TodayDataError } = useGeoFetch(
  //   lastDisplayDateNew,
  //   lastDisplayDateNew,
  //   entity,
  //   'zip3'
  // )

  // useEffect(() => {
  //   if (zip3TodayData !== null && zip3TodayData !== undefined) {
  //     if (zip3TodayData.response_code === 200) {
  //       setzip3(zip3TodayData.response_data)
  //     } else {
  //       setErrorCode(zip3TodayData.response_code)
  //       setErrorMessage(zip3TodayData.response_message)
  //       setErrorSubject(zip3TodayData.response_subject)
  //       seterrorOccured(true)
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [zip3TodayData])

  const { data: zip3Data, error: zip3DataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    entity,
    'zip3'
  )

  useEffect(() => {
    if (zip3Data !== null && zip3Data !== undefined) {
      if (zip3Data.response_code === 200) {
        setzip3(zip3Data.response_data)
      } else {
        setErrorCode(zip3Data.response_code)
        setErrorMessage(zip3Data.response_message)
        setErrorSubject(zip3Data.response_subject)
        seterrorOccured(true)
      }
    }
  }, [zip3Data])

  // Active Metro Areas
  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    entity,
    'activecbsa'
  )
  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      if (activeCbsasData.response_code === 200) {
        if (Object.keys(activeCbsasData.response_data).length > 0)
          setActiveCBSA(activeCbsasData.response_data)
      } else {
        setErrorCode(activeCbsasData.response_code)
        setErrorMessage(activeCbsasData.response_message)
        setErrorSubject(activeCbsasData.response_subject)
        seterrorOccured(true)
      }
    }
    //setMetros(cbsaData)
  }, [activeCbsasData])

  // Active Metro Areas
  const { data: activeZip3sData, error: aactiveZip3sDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    entity,
    'activecbsa',
    '',
    {
      areaType: 'zip3',
    }
  )
  useEffect(() => {
    if (activeZip3sData !== null && activeZip3sData !== undefined) {
      if (activeZip3sData.response_code === 200) {
        if (Object.keys(activeZip3sData.response_data).length > 0)
          setActiveZip3(activeZip3sData.response_data)
      } else {
        setErrorCode(activeZip3sData.response_code)
        setErrorMessage(activeZip3sData.response_message)
        setErrorSubject(activeZip3sData.response_subject)
        seterrorOccured(true)
      }
    }
    //setMetros(cbsaData)
  }, [activeZip3sData])

  const {
    data: activeCbsasDataForSearch,
    error: activeCbsasDataErrorForSearch,
  } = useGeoFetch('', '', 'search', 'locations/FLU', '', {
    geo_type: 'MSA',
  })

  useEffect(() => {
    if (
      activeCbsasDataForSearch !== null &&
      activeCbsasDataForSearch !== undefined
    ) {
      setActiveCbsaForSearch(activeCbsasDataForSearch)
    }
  }, [activeCbsasDataForSearch])

  const { data: activeZip3DataForSearch, error: activeZip3DataErrorForSearch } =
    useGeoFetch('', '', 'search', 'locations/FLU', '', {
      geo_type: 'ZIP3',
    })

  useEffect(() => {
    if (
      activeZip3DataForSearch !== null &&
      activeZip3DataForSearch !== undefined
    ) {
      setactiveZip3ForSearch(activeZip3DataForSearch)
    }
  }, [activeZip3DataForSearch])

  // State Combined data for right side graph view
  const { data: statesCombinedData, error: statesCombinedDataError } =
    useGeoFetch(dataStartDate, dataEndDate, entity, 'state?seasons=all')

  useEffect(() => {
    if (statesCombinedData !== null && statesCombinedData !== undefined) {
      if (statesCombinedData.response_code === 200) {
        setStatesCombinedData(statesCombinedData.response_data)
      } else {
        setErrorCode(statesCombinedData.response_code)
        setErrorMessage(statesCombinedData.response_message)
        setErrorSubject(statesCombinedData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statesCombinedData])

  if (statesCombinedDataError || aactiveZip3sDataError || errorOccured) {
    console.log(
      `the error occured is ${errorMessage}, ${errorSubject}, ${errorCode}`
    )
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }
   
const timelineStatesData = Object.fromEntries(
  Object.entries(states ?? []).map(([date, obj]) => {
    const { epi_period_week, epi_period_year, epi_season, ...rest } = obj;
    return [date, rest];
  })
);


  const setFluMsaData = (flumsa) => {
    setMetros(flumsa)
  }

  return (
    <div className={`${styles.base}`}>
      <div className={styles.filterPanelHeader}>
        <div className={styles.displaySelect}>
          <MapOptions
            regionDisplayOptions={regionDisplayOptions}
            dataDisplayOptions={dataDisplayOptions}
            mapType="FLUMAP"
          />
        </div>
        <div className={styles.pageHeaderSearch}>
          {activeCbsaForSearch !== undefined &&
            activeZip3ForSearch !== undefined && (
              <Search
                criteria={searchCriteria}
                onChange={setSearchCriteria}
                entity={'Flu'}
                activeMetros={activeCbsaForSearch}
                activeZip3={activeZip3ForSearch}
                fluToggleEnabled={toggleEnabled}
                placeholder={'Search State, MSA or Zip3'}
              />
            )}
        </div>
        <div className={styles.pageHeaderExport}>
          {exportButtonState === true ||
          regionSelected === 'zip3' ||
          exportButtonEnable === false ? (
            <button className={styles.buttonClassDisable}>Export</button>
          ) : (
            <button
              className={styles.buttonClass}
              onClick={() => {
                handleClick()
              }}
            >
              Export
            </button>
          )}
        </div>
        <div>
          <span className={styles.switchlabel}>Dashboard Mode</span>
          <Toggle
            checked={toggleEnabled}
            onChange={setToggleEnabled}
            onLabel="ON"
            offLabel="OFF"
            id="notifications-toggle"
          />
        </div>
        <div style={{ marginTop: '30px' }}>
          <span className={styles.firstSpan}> {getgeoid}</span>
          <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
          <span className={true ? styles.stdatavalueup : styles.datavaluedown}>
            {' '}
            {getPercentage}%{' '}
          </span>
          <span className={styles.forthSpan}> ({getDatavalue})</span>
        </div>
        {exportButtonState === true ? (
          <ExportExcelApi disease={'Flu'} setExcelData={setExcelRowData} />
        ) : (
          ''
        )}
      </div>
      <div className={`${styles.datePanel}`}>
        {/* <h2>Influenza Level</h2>
        <span>
          Actual and forecasted influenza levels based on claims data.
        </span> */}
        <DefaultBreadcrumbs
          geo_id={'NAT'}
          geo_type={'NAT'}
          dashboardType={'flu'}
        />

        <SelectList
          dropdownData={typeDisplayOptions}
          defaultValue={'flu'}
          defaultLabel={'Flu Incidence'}
        />
      </div>

      <div className={`${styles.cbsasPanel}`}>
        <>
          {regionSelected === 'state' && (
            <>
              {states !== undefined ? (
                <StateStats
                  stateData={states}
                  chartRef={chartRef}
                  mapOptions={mapOptions}
                  toggleEnabled={toggleEnabled}
                />
              ) : (
                <Spinner />
              )}
            </>
          )}

          {regionSelected === 'metro' && (
            <>
              <FluMsaApi cbsaMetroData={setFluMsaData} />
              {metros !== undefined ? (
                <CbsaStats
                  cbsaJson={getCbsaJsonFile}
                  cbsaData={metros}
                  chartRef={chartRef}
                  mapOptions={mapOptions}
                  toggleEnabled={toggleEnabled}
                />
              ) : (
                <Spinner />
              )}
            </>
          )}
          {regionSelected === 'zip3' && (
            <>
              {/* <FluMsaApi cbsaMetroData={setFluMsaData} /> */}
              {zip3s !== undefined ? (
                <Zip3Stats
                  zip3SearchData={activeZip3ForSearch}
                  zip3Data={zip3s}
                  chartRef={chartRef}
                  mapOptions={mapOptions}
                  toggleEnabled={toggleEnabled}
                />
              ) : (
                <Spinner />
              )}
            </>
          )}
        </>
      </div>

      {/* Map Panel */}
      <div className={`${styles.map}`}>
        <div className={`${styles.timelinePanel}`}>
          {states !== undefined && (
            <DisplayDateFluNew
              statesData={getMapStates}
              showWeek={true}
              latestPositionString={latestPositionString}
              slotString={slotString}
              slotTimeInSeconds={slotTimeInSeconds}
              diseaseType={'Flu'}
            />
          )}
          {states !== undefined && (
            <Timeline
              statesData={getMapStates}
              latestPositionString={latestPositionString}
              slotString={slotString}
              slotTimeInSeconds={slotTimeInSeconds}
              markCounts={6}
              loadError={stateDataError}
            />
          )}
        </div>
        <div className={styles.legendDiv}>
          <MapLegend />
        </div>

        {hash && hash !== '#map' && getCbsaJsonFile && (
          <div className={styles.mapPopup}>
            <FluDetailedViewComponent
              statesData={getStatesCombinedData}
              hash={hash}
              stateJson={getStateJsonFile}
              cbsaJson={getCbsaJsonFile}
              zip3Json={getZip3JsonFile}
            />
          </div>
        )}

        {regionSelected === 'state' && (
          <>
            {states !== undefined && getStateJsonFile ? (
              <Map
                toolTipFormatter={toolTipFormatter}
                activeCbsasData={null}
                statesData={states}
                cbsaData={null}
                chartRef={chartRef}
                mapOptions={mapOptions}
                dynamicMapTitle={true}
                mapType="FLUMAP"
                mapDataType={0}
                enableButtons={true}
                stateJson={getStateJsonFile}
                toggleEnabled={toggleEnabled}
                dashboardType="state"
              />
            ) : (
              <EmptyMap stateJson={getStateJsonFile} />
            )}
          </>
        )}

        {regionSelected === 'metro' && (
          <>
            {metros !== undefined &&
            getActiveCBSA !== undefined &&
            getStateJsonFile ? (
              <Map
                toolTipFormatter={toolTipFormatter}
                activeCbsasData={getActiveCBSA}
                statesData={states}
                cbsaData={metros}
                chartRef={chartRef}
                mapOptions={mapOptions}
                dynamicMapTitle={true}
                mapType="FLUMAP"
                mapDataType={1}
                enableButtons={true}
                stateJson={getStateJsonFile}
                cbsaJson={getCbsaJsonFile}
                toggleEnabled={toggleEnabled}
                dashboardType="metro"
              />
            ) : (
              <EmptyMap stateJson={getStateJsonFile} />
            )}
          </>
        )}

        {regionSelected === 'zip3' && (
          <>
            {zip3s !== undefined &&
            getActiveZip3 !== undefined &&
            getZip3JsonFile ? (
              <Map
                toolTipFormatter={toolTipFormatter}
                activeCbsasData={null}
                activeZip3Data={getActiveZip3}
                statesData={states}
                cbsaData={null}
                chartRef={chartRef}
                mapOptions={mapOptions}
                dynamicMapTitle={true}
                mapType="ZIP3MAP"
                enableButtons={true}
                toggleEnabled={toggleEnabled}
                dashboardType="zip3"
                stateJson={getStateJsonFile}
                zip3Json={getZip3JsonFile}
                zip3Data={zip3s}
              />
            ) : (
              <EmptyMap stateJson={getStateJsonFile} />
            )}
          </>
        )}
      </div>

      {/* <div className={`${styles.timelinePanel}`}>
        {states !== undefined && (
          <DisplayDateFluNew
            showWeek={false}
            latestPositionString={latestPositionString}
            slotString={slotString}
            slotTimeInSeconds={slotTimeInSeconds}
          />
        )}
        {states !== undefined && (
          <Timeline
            statesData={states}
            latestPositionString={latestPositionString}
            slotString={slotString}
            slotTimeInSeconds={slotTimeInSeconds}
            markCounts={11}
            loadError={stateDataError}
          />
        )}
      </div> */}
      <div className={styles.genderSeasonalPanel}>
        <Gender geo_type="NAT" geo_id="NAT" data_type="FLU" />
        <SeasonalPattern geo_type="NAT" geo_id="NAT" data_type="FLU" />
      </div>
    </div>
  )
}

export default FluGeo
